
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isMessageThread = pathname.includes('/chat/') || pathname.includes('/conversations/');
    
    if (isMessageThread) {
      // For message threads, scroll to bottom after a brief delay to ensure content is loaded
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 100);
    } else {
      // For all other routes, scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
